import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MenuLateral from './components/MenuLateral.jsx';

function Profile() {
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const [hovered, setHovered] = useState(false);
    
    const [userData, setUserData] = useState(() => {
        const savedUser = localStorage.getItem('user');
        return savedUser ? JSON.parse(savedUser) : { name: "Carregando...", username: "", profile_picture: "" };
    });
    
    const [newPassword, setNewPassword] = useState("");
    
    // Estados para News Interests
    const [newsInterests, setNewsInterests] = useState([]);
    const [newQuery, setNewQuery] = useState("");

    const [newsSources, setNewsSources] = useState([]);
    const [newDomain, setNewDomain] = useState("");

    const [nameInput, setNameInput] = useState('');
    const [passwordInput, setPasswordInput] = useState('');
    
    const [isHovered, setIsHovered] = useState(false);

    const handleUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await fetch(`https://hubdaive.com.br/api/users/${userData.id}/upload-profile-pic`, {
            method: 'POST',
            body: formData,
            });

            if (response.ok) {
                const data = await response.json();
                const newPicUrl = `https://hubdaive.com.br${data.profile_picture}?t=${new Date().getTime()}`;
                // setUserData({ ...userData, profile_picture: newPicUrl });
                const updatedUser = { ...userData, profile_picture: newPicUrl };
                setUserData(updatedUser);
                localStorage.setItem('user', JSON.stringify(updatedUser))
                // alert("Foto atualizada com sucesso!");
                }
            } catch (error) {
                console.error("Erro ao subir imagem:", error);
            }
    };

    const handleDeletePic = async (e) => {
        e.stopPropagation();
        
        if (!window.confirm("Deseja realmente remover sua foto de perfil?")) return;

        try {
            const response = await fetch(`https://hubdaive.com.br/api/users/${userData.id}/profile-pic`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` },
            });

            if (response.ok) {
                const updatedUser = { ...userData, profile_picture: null };
                setUserData(updatedUser);
                localStorage.setItem('user', JSON.stringify(updatedUser));
            }
        } catch (error) {
            console.error("Erro ao deletar foto:", error);
        }
    };
    
    const overlayStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.6)', // Escurece a foto
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: isHovered ? 1 : 0, // Só aparece no hover
        transition: 'opacity 0.3s ease', // Efeito suave
        color: '#fff',
        fontSize: '2rem',
        fontWeight: '300'
    };

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                const headers = { 'Authorization': `Bearer ${token}` };
                
                // Busca Perfil
                const profileRes = await fetch('https://hubdaive.com.br/api/me', { headers });
                if (profileRes.ok) {
                    const data = await profileRes.json();
                    if (data.profile_picture) {
                    data.profile_picture = `https://hubdaive.com.br${data.profile_picture}?t=${new Date().getTime()}`;
                }
                    setUserData(data);
                    localStorage.setItem('user', JSON.stringify(data));
                }

                // Busca Interesses de News 
                const newsRes = await fetch('https://hubdaive.com.br/api/news/interests', { headers });
                if (newsRes.ok) {
                    const newsData = await newsRes.json();
                    setNewsInterests(newsData);
                }
                const sourcesRes = await fetch('https://hubdaive.com.br/api/news/sources', { headers });
                if (sourcesRes.ok) {
                    const sourcesData = await sourcesRes.json();
                    setNewsSources(sourcesData);
                }
            } catch (error) {
                console.error("Erro ao carregar dados:", error);
            }
        };
        fetchAllData();
    }, [token]);

    // --- Função para Adicionar Interesse ---
    const handleAddNews = async () => {
        if (!newQuery.trim()) return;
        
        try {
            const response = await fetch('https://hubdaive.com.br/api/news/interests', {
                method: 'POST',
                headers: { 
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' 
                },
                body: JSON.stringify({ query: newQuery })
            });

            if (response.ok) {
                const addedNews = await response.json();
                // setNewsInterests([...newsInterests, { id: addedNews.id, query: newQuery }]);
                setNewsInterests([...newsInterests, addedNews]);
                setNewQuery("");
            }
        } catch (error) {
            console.error("Erro ao adicionar news interest:", error);
        }
    };

    const handleAddSource = async () => {
        if (!newDomain.trim()) return;
        
        // Remove apenas http/https e www, mas MANTÉM o path
        const cleanDomain = newDomain.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "");

       try {
            const response = await fetch('https://hubdaive.com.br/api/news/sources', {
                method: 'POST',
                headers: { 
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' 
                },
                // Alterado de 'domain' para 'url' para coincidir com o esperado pelo banco
                body: JSON.stringify({ url: cleanDomain }) 
            });

            if (response.ok) {
                const addedSource = await response.json();
                
                setNewsSources([...newsSources, addedSource]);
                setNewDomain("");
            } else {
                const errData = await response.json();
                alert("Erro ao adicionar fonte: " + (errData.detail || "Verifique a rota"));
            }
        } catch (error) {
            console.error("Erro ao adicionar fonte:", error);
        }
    };

    const handleDeleteSource = async (id) => {
        try {
            const response = await fetch(`https://hubdaive.com.br/api/news/sources/${id}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (response.ok) {
                setNewsSources(newsSources.filter(item => item.id !== id));
            }
        } catch (error) {
            console.error("Erro ao deletar fonte:", error);
        }
    };

    const handleSave = async () => {
        const updateData = {};
        
        if (userData.name && userData.name.trim() !== "") updateData.name = userData.name;
        if (newPassword && newPassword.trim() !== "") updateData.password = newPassword;

        if (Object.keys(updateData).length === 0) {
            alert("Preencha o nome ou a senha para alterar.");
            return;
        }

        try {
            const response = await fetch("https://hubdaive.com.br/api/users/update-profile", {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify(updateData)
            });

            if (response.ok) {
                const result = await response.json();
                const updatedUser = { ...userData, name: result.name };
                setUserData(updatedUser);
                localStorage.setItem('user', JSON.stringify(updatedUser));
                setNewPassword('');
                alert("Dados atualizados com sucesso!");
            } else {
                const error = await response.json();
                alert("Erro ao atualizar: " + (error.detail || "Erro desconhecido"));
            }
        } catch (err) {
            console.error("Erro na requisição:", err);
            alert("Não foi possível conectar ao servidor.");
        }
    };

    const handleDeleteNews = async (id) => {
        try {
            const response = await fetch(`https://hubdaive.com.br/api/news/interests/${id}`, {
                method: 'DELETE',
                headers: { 
                    'Authorization': `Bearer ${token}` 
                }
            });

            if (response.ok) {
                setNewsInterests(newsInterests.filter(item => item.id !== id));
            } else {
                console.error("Erro ao deletar interesse");
            }
        } catch (error) {
            console.error("Erro na requisição DELETE:", error);
        }
    };

    const handleLogout = () => {
        // 1. Limpa o token e os dados do usuário
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('rememberMePreference'); // Limpa a preferência do checkbox
        
        // 2. Limpa o sessionStorage caso ele tenha logado sem o "Lembrar"
        sessionStorage.clear();
        
        // 3. Manda de volta para a tela de Login
        navigate('/');
    };

    return (
        <div style={containerStyle}>

            <div style={cardStyle}>
                <div 
                    style={{
                        ...avatarStyle,      
                        position: 'relative',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#262626',
                        filter: isHovered ? 'brightness(0.6)' : 'brightness(1)',
                        transition: 'all 0.3s ease',
                        overflow:'visible'
                    }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={() => document.getElementById('fileInput').click()}
                >
                    {/* 1. Foto de Perfil (Só aparece se existir) */}
                    {userData.profile_picture ? (
                    <>
                        <img 
                            src={userData.profile_picture} 
                            alt="Profile" 
                            style={{ 
                                width: '100%', 
                                height: '100%',
                                borderRadius: '50%', 
                                objectFit: 'cover',
                                transition: 'transform 0.3s ease',
                                transform: isHovered ? 'scale(1.1)' : 'scale(1)'
                            }} 
                        />
                        {isHovered && (
                            <button
                                onClick={handleDeletePic}
                                style={{
                                    position: 'absolute',
                                    top: '-5px',
                                    right: '-8px',
                                    backgroundColor: 'rgba(255, 77, 77, 0.9)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '1.5vw',
                                    height: '1.5vw',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    zIndex: 3000,
                                    boxShadow: '0 2px 5px rgba(0,0,0,0.3)'
                                }}
                                title="Remover foto"
                            >
                                ×
                            </button>
                        )}
                    </>
                ) : (
                    <div style={{ color: '#555', fontSize: '1vh' }}>{isHovered ? '' : 'Sem Foto'}</div>
                )}

                    <span style={{
                        position: 'absolute',
                        color: '#fff',
                        fontSize: '3vh',
                        fontWeight: 'bold',
                        opacity: isHovered ? 1 : 0,
                        transform: isHovered ? 'scale(1) translate(-50%, -50%)' : 'scale(0.5) translate(-50%, -50%)',
                        transition: 'all 0.3s ease',
                        top: '50%',
                        left: '50%',
                        transformOrigin: '0 0', 
                        pointerEvents: 'none', 
                        textShadow: '0 0 10px rgba(0,0,0,0.5)'
                    }}>
                        +
                    </span>
                </div>
                <input 
                    id="fileInput"
                    type="file" 
                    style={{ display: 'none' }} 
                    accept="image/*"
                    onChange={handleUpload}
                />

                    <h2 style={{ marginBottom: '4vh', fontSize: '3vh' }}>Configurações de Perfil</h2>

                    <div style={formContainerStyle}>
                        <div>
                            <label style={labelStyle}>NOME COMPLETO</label>
                            <input type="text" value={userData.name} onChange={(e) => setUserData({...userData, name: e.target.value})} style={inputStyle} />
                        </div>

                        <div>
                            <label style={labelStyle}>NOVA SENHA</label>
                            <input type="password" placeholder="Deixe em branco para não alterar" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} style={inputStyle} />
                        </div>

                        {/* --- SEÇÃO DE NEWS INTERESTS --- */}
                        <div style={{ marginTop: '2vh' }}>
                            <label style={labelStyle}>INTERESSES DE NOTÍCIAS (SEARCH)</label>
                            <div style={{ display: 'flex', gap: '10px', marginTop: '1.5vh' }}>
                                <input 
                                    placeholder="Ex: Marketing, IA, Publicidade..." 
                                    value={newQuery} 
                                    onChange={(e) => setNewQuery(e.target.value)}
                                    style={{ ...inputStyle, marginTop: 0 }} 
                                />
                                <button onClick={handleAddNews} style={addButtonNewsStyle}>+</button>
                            </div>

                            <div style={tagContainerStyle}>
                                {newsInterests.map((item) => (
                                    <span key={item.id} style={tagStyle}>
                                        {item.query}
                                        <button 
                                            onClick={() => handleDeleteNews(item.id)}
                                            style={removeTagButtonStyle}
                                        >
                                            ×
                                        </button>
                                    </span>
                                ))}
                            </div>
                        </div>
                        {/* --- SEÇÃO DE NEWS SOURCES (DOMÍNIOS) --- */}
                        <div style={{ marginTop: '3vh' }}>
                            <label style={labelStyle}>FONTES PREFERIDAS (DOMÍNIOS)</label>
                            <div style={{ display: 'flex', gap: '10px', marginTop: '1.5vh' }}>
                                <input 
                                    placeholder="Ex: tecnoblog.net, g1.globo.com" 
                                    value={newDomain} 
                                    onChange={(e) => setNewDomain(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && handleAddSource()}
                                    style={{ ...inputStyle, marginTop: 0 }} 
                                />
                                <button onClick={handleAddSource} style={{...addButtonNewsStyle, backgroundColor: '#34C759'}}>+</button>
                            </div>

                            <div style={tagContainerStyle}>
                                {newsSources.map((source) => (
                                    <span key={source.id} style={{...tagStyle, color: '#34C759', borderColor: '#1b4324'}}>
                                        {source.domain}
                                        <button 
                                            onClick={() => handleDeleteSource(source.id)}
                                            style={{...removeTagButtonStyle, color: '#34C759'}}
                                        >
                                            ×
                                        </button>
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                    <button onClick={handleSave} style={saveButtonStyle}>Salvar Alterações</button>
                    <button onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} onClick={() => navigate('/home')} style={{textDecoration: hovered ? 'underline' : 'none', ...backButtonStyle}}>Voltar para o menu principal</button>
                    <button onClick={handleLogout} style={{...backButtonStyle,marginTop: '1.5vh',color: '#ff4d4d', fontWeight: 'bold', display: 'block',width: '100%'}}>Sair da Conta</button>
                </div>
        </div>
    );
}

const addButtonNewsStyle = {
    backgroundColor: '#007AFF',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    padding: '0 1vw',
    cursor: 'pointer',
    fontSize: '3vh'
};

const tagContainerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    marginTop: '2vh'
};

const tagStyle = {
    backgroundColor: '#222',
    color: '#007AFF',
    padding: '1vh 1.5vw',
    borderRadius: '15px',
    fontSize: '2vh',
    border: '1px solid #333'
};

const removeTagButtonStyle = {
    background: 'none',
    border: 'none',
    color: '#4dabf7',
    marginLeft: '0.5vw',
    cursor: 'pointer',
    fontSize: '2vh',
    fontWeight: 'bold',
    padding: '0 2px',
    lineHeight: '1',
    display: 'inline-flex',
    alignItems: 'center',
    transition: 'color 0.2s',
};


const containerStyle = { height: '130vh', maxWidth: '100vw', backgroundColor: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Helvetica', color: '#fff', position: 'relative' };
const cardStyle = { width: '20vw',minHeight:'90vh', padding: '5vh',marginTop: '2.5vh', marginBottom:'2.5vh', backgroundColor: '#111', borderRadius: '20px', border: '1px solid #222', boxShadow: '0 2vh 3vw rgba(0,0,0,0.5)', textAlign: 'center' };
const avatarStyle = { position: 'relative', display: 'inline-block',width: '4vw', height: '8vh', backgroundColor: '#333', borderRadius: '50%', overflow:'visible', margin: '0 auto 3vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '5px', border: '2px solid #007AFF' };
const labelStyle = { fontSize: '1.5vh', color: '#888', letterSpacing: '1px' };
const formContainerStyle = { display: 'flex', flexDirection: 'column', gap: '20px', textAlign: 'left' };
const inputStyle = { width: '100%', padding: '2vh 0', backgroundColor: 'transparent', border: 'none', borderBottom: '1px solid #333', color: '#fff', outline: 'none', fontSize: '1.8vh', marginTop: '1vh' };
const saveButtonStyle = { width: '90%', padding: '2.5vh', backgroundColor: '#007AFF', color: '#fff', border: 'none', borderRadius: '10px', marginTop: '4vh', cursor: 'pointer', fontWeight: 'bold', fontSize:'1.8vh' };
const backButtonStyle = { background: 'none', border: 'none', color: '#888', marginTop: '3vh', cursor: 'pointer', fontSize: '1.8vh' };

export default Profile;